import React from 'react';
import type { DossierSectionStatus } from '../../../services/CrmDossierService';

interface Props {
  status: DossierSectionStatus;
  isEmpty: boolean;
  emptyText: string;
  unavailableText: string;
  failedSources?: string[];
  onRetry?: () => void;
  children: React.ReactNode;
}

/** Vazio honesto é diferente de falha: falha nunca vira lista vazia. */
const DossierSectionState: React.FC<Props> = ({ status, isEmpty, emptyText, unavailableText, failedSources, onRetry, children }) => {
  if (status === 'unavailable') {
    return (
      <div className="dossier-state dossier-state--error">
        <p role="alert">{unavailableText}</p>
        {onRetry && (
          <button type="button" className="dossier-btn" onClick={onRetry}>
            Tentar de novo
          </button>
        )}
      </div>
    );
  }
  return (
    <>
      {status === 'partial' && failedSources && failedSources.length > 0 && (
        <p className="dossier-note dossier-note--warn">{`Parte não carregou: ${failedSources.join(', ')}.`}</p>
      )}
      {isEmpty ? <p className="dossier-empty">{emptyText}</p> : children}
    </>
  );
};

export default DossierSectionState;
